const localCmsData = () => ({
  summary: {
    title: {
      cartTitle: 'My cart',
      breakdownTitle: 'Total Breakdown',
    },
    monthlyText: {
      title: 'Monthly cost',
      subtitle: '',
    },
    onceOffText: {
      title: 'Once off',
      subtitle: 'It will be added only to your 1st bill',
    },
    upfrontText: {
      title: 'Upfront cost',
    },
    payTodayText: {
      title: 'Pay today',
      subtitle: 'Price for the handset',
      simoBillPaySubTitle: 'Handset cost and activation fee',
      mbbSubtitle: 'Price for the device',
      mbbMobileBillPaySubTitle: 'Price for the devices',
      mbbMobileSIMOSubTitle: 'Device cost and activation fee',
      mbbBillPaySIMOSubTitle: 'Price for the devices and activation fee',
      depositTitle: 'Price for the handset and deposit',
    },
    cartItemText: {
      broadbandTitle: 'Broadband',
      tvTitle: 'TV',
      mobileTitle: 'Mobile plans',
      simTitle: 'SIM only',
      mbbTitle: 'Mobile Broadband',
    },
    packageSummary: {
      title: 'New eir package',
      monthlyCostText: 'New monthly cost',
      payTodayText: 'Pay today',
    },
    contactDetailsText: {
      title: 'Customer information',
      billingAddress: 'Billing address:',
      deliveryAddress: 'Delivery address:',
      subText: 'This is the address where you would like your box being delivered.',
    },
    changeOffer: {
      bbUpgrade: 'Broadband Upgrade',
      bbRecontract: 'Broadband Recontract',
      mbUpgrade: 'Mobile Upgrade',
      mbRecontract: 'Mobile Recontract',
      mbPlanChange: 'Mobile Plan Change',
      upsellTV: 'New TV',
    },

    crossSell: {
      mobile: 'New Mobile',
      tv: 'New TV',
      broadband: 'New Broadband',
      mbb: 'New Mobile Broadband',
    },
  },
  prepaySummary: {
    title: 'My cart',
    topUp: 'Top up',
    payToday: 'Pay today',
    topUpPlan: 'Top up your plan',
    topUpPlanSubText: 'Do you want to add any additional credit to your plan?',
    portInTitle: 'Schedule your number move',
  },
  payment: {
    title: 'Choose a payment method:',
    savedCardPaymentTitle: 'Previously used card',
    upfrontPaymentTitle: 'Pay with another card',
    pickSavedCardTitle: 'Pick a saved card',
  },
});
export default localCmsData;
